var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('h5',{staticClass:"flex-grow-1"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"close-button-container"},[_c('CloseButton',{attrs:{"onClick":_vm.onCloseButton,"id":_vm.closeButtonId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }